import { memo } from 'react';

import { Stack } from '@chakra-ui/react';

import { Text } from 'ui/Text';

interface CardUserDetailsProps {
  color?: string;
  owner?: string;
  street?: string;
  address?: string;
}

const CardUserDetails = ({
  owner = '',
  street = '',
  address = '',
  color = ''
}: CardUserDetailsProps) => (
  <Stack
    display='flex'
    flexDirection={{ base: 'row', lg: 'column' }}
    alignItems={{ base: 'center', lg: 'flex-start' }}
    flexWrap='wrap'
    h='100%'
    gap={{ base: 1, sm: 0 }}
  >
    {owner && (
      <Text
        color={color}
        fontSize='15px'
        fontWeight='regular'
        lineHeight='22px'
        textAlign='left'
      >
        {owner}
      </Text>
    )}
    {street && (
      <Text
        color={color}
        fontSize='15px'
        fontWeight='regular'
        lineHeight='22px'
        textAlign='left'
      >
        {street}
      </Text>
    )}
    {address && (
      <Text
        color={color}
        fontSize='15px'
        fontWeight='regular'
        lineHeight='22px'
        textAlign='left'
      >
        {address}
      </Text>
    )}
  </Stack>
);

export default memo(CardUserDetails);
